import { LotteryTicket } from 'config/constants/types';
import { getLotteryV2Contract } from 'utils/contractHelpers';

const lotteryContract = getLotteryV2Contract();

export const viewUserInfoForLotteryId = async (
  account: string,
  lotteryId: string,
): Promise<LotteryTicket[]> => {
  try {
    const ticketIds = await lotteryContract.viewUserTickets(account, lotteryId);

    const ticketData = await Promise.all(
      ticketIds.map(async (ticketId) => {
        const [number, owner, claimed] = await lotteryContract.getTicket(ticketId);
        return {
          id: ticketId.toString(),
          number: number.toString(),
          status: claimed, // true if claimed, false otherwise
        };
      }),
    );

    return ticketData;
  } catch (error) {
    console.error('viewUserInfoForLotteryId', error);
    return [];
  }
};

export const fetchUserTicketsForOneRound = async (
  account: string,
  lotteryId: string,
): Promise<LotteryTicket[]> => {
  return viewUserInfoForLotteryId(account, lotteryId);
};

export const fetchUserTicketsForMultipleRounds = async (
  idsToCheck: string[],
  account: string,
): Promise<{ roundId: string; userTickets: LotteryTicket[] }[]> => {
  const ticketsForMultipleRounds = [];

  for (let i = 0; i < idsToCheck.length; i++) {
    const roundId = idsToCheck[i];
    // eslint-disable-next-line no-await-in-loop
    const ticketsForRound = await fetchUserTicketsForOneRound(account, roundId);
    ticketsForMultipleRounds.push({
      roundId,
      userTickets: ticketsForRound,
    });
  }

  return ticketsForMultipleRounds;
};
